<template>
  <div class="whats-new">
    <modal v-if="isModalOpen" @close="closeModal">
      <div slot="header" class="imprint__header">
        <h1>{{ $t('Web.expert_view_news_title') }}</h1>
      </div>
      <div slot="body" class="whats-new__body">
        <div class="whats-new__body--inner" v-if="newsDocument">
          <article class="whats-new__item">
            <div class="whats-new__item--content" v-html="decodeLegalDocs(newsDocument)"></div>
          </article>
        </div>
      </div>
      <div slot="footer"></div>
    </modal>
  </div>
</template>

<script>
import _has from 'lodash/has';
import { mapGetters, mapActions } from 'vuex';

import Modal from '../_common/modal.vue';

export default {
  components: { Modal },
  data() {
    return {
      isModalOpen: true
    };
  },
  beforeCreate() {
    this.$showGlobalLoadingSpinner();
    this.$store
      .dispatch('getNewsKey')
      .then(() => {
        this.$store.dispatch('getAcceptedNews');
      })
      .finally(() => {
        this.$hideGlobalLoadingSpinner();
      });
  },

  methods: {
    ...mapActions(['updateProfile']),

    closeModal() {
      // if there is a previous route, navigate to it. Otherwise go to home route.
      // We check for > 2 because an empty browser tab/page counts already as one
      // and we want to ensure that closing this modal will not lead to a blank tab/page.
      if (window.history && window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    },
    updateProfileNews() {
      const profileObj = this.getProfileObject();

      profileObj.news = this.newsKey.latest;

      Promise.all([this.updateProfile(this.$sanitize(JSON.stringify(profileObj)))]).then(() => {
        this.$store.dispatch('setHasNewsAccepted', true);
      });
    },
    decodeLegalDocs(response) {
      if (_has(response.data, 'html')) {
        try {
          const content = atob(response.data.html);

          return decodeURIComponent(escape(content));
        } catch (e) {
          // @TODO Update i18n strings
          return 'Fehler. Es wird kein valides Dokument ausgeliefert.';
        }
      }
    },
    getProfileObject() {
      return {
        ...this.profile,
        news: this.profile.news
      };
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'profile', 'hasAcceptedNews', 'newsKey', 'newsDocument'])
  },
  mounted() {
    // Page is ready, update user profile `news` value
    this.updateProfileNews();
  }
};
</script>
<style lang="scss">
.whats-new__item--content {
  font-family: $font-siemens;

  position: relative;
  z-index: 0;
  max-width: 720px;
  background: #fff;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
